module.exports = require('./helpers/bundle-url').getBundleURL('au4zy') + "SplashScreen.7c4f6d58.png" + "?" + Date.now();